module.exports = __webpack_public_path__ + "img/G3 device.3b96e849.svg";